export enum SearchPersonalisation {
  NAME = 'search_personalisation',
  PERSONALISED = 'personalised',
  UNPERSONALISED = 'unpersonalised',
}
